import Inquiry from './Inquiry';
import Listing from './Listing';

const LeadsDetails = ({ excelFilename = '', inquiry = {}, listing = {}, phoneCallsByGuid = {} } = {}) => ({
  excelFilename: String(excelFilename),
  inquiry: Inquiry(inquiry),
  listing: Listing(listing),
  phoneCallsByGuid: Object(phoneCallsByGuid),
});

export default LeadsDetails;

export type LeadsDetailsProps = ReturnType<typeof LeadsDetails>;
